import { createFileRoute } from '@tanstack/react-router';
import { OAuthCallback } from '@/pages';

export const Route = createFileRoute('/_public/oauth/callback')({
  component: OAuthCallback,
});
